import {
  Directive,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output
} from "@angular/core";
import { Bind } from "src/app/support/decorators/bind";

@Directive({
  selector: "[hostListener]",
  standalone: false
})
export class HostListenerDirective implements OnInit, OnDestroy {
  @Input("hostListener")
  hostListener!: string;

  @Output()
  fire: EventEmitter<any> = new EventEmitter<any>();

  constructor(private elementRef: ElementRef<HTMLElement>) {}

  ngOnInit(): void {
    this.elementRef.nativeElement.addEventListener(
      this.hostListener,
      this.listener
    );
  }

  @Bind
  listener(event: any): void {
    this.fire.emit(event);
  }

  ngOnDestroy() {
    this.elementRef.nativeElement.removeEventListener(
      this.hostListener,
      this.listener
    );
  }
}
